/**
 * Creates a textarea element that is used in the FreeText markup creation process.
 */
export function createEditorTextarea(initText = ''): HTMLTextAreaElement {
  const element = document.createElement('textarea');
  element.style.fontFamily = 'Helvetica'; // need to add helvetica as font?
  element.style.backgroundColor = 'transparent';
  element.style.resize = 'none';
  element.style.outline = 'none';
  element.style.fontSize = '12px';
  element.style.lineHeight = '13.8px';
  element.style.padding = '6px 4px';
  element.value = initText;

  return element;
}
